
import '@/assets/scss/index.scss'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import { commonfunc } from '~/mixin/common'
import mbUtils from '~/scriptData/mb/utils/mbUtils'
import { pdMixin } from '@/mixin/pd/pdMixin'
import orMixin from '~/mixin/or/orMixin'
import ScrMbc011502 from '@/pages/mb/mbc/SCR_MBC_0115_02.vue'
import AddressCard from '~/components/common/address/AddressCard.vue'
import NoData from '~/components/common/template/NoData.vue'
import TotalCount from '~/components/common/sort/TotalCount.vue'

export default {
  components: {
    NoData,
    TotalCount,
    AddressCard,
    ScrMbc011502
  },
  mixins: [commonfunc, mbUtils, orMixin, pdMixin],
  props: {
    ppupType: { // 팝업 타입, ppupType: 상품 상세에서 접근한 경우
      type: String,
      default: ''
    },
    purchaseValue: { // 배송 유형 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    dlvUnable: {
      type: Boolean,
      default: false
    },
    currentDvya: {
      type: Object,
      default: () => {
        return {}
      }
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      outerVisible: false,
      list: [],
      isLoaded: false,
      mbMngNo: '',
      selIdx: -1,
      isDisabled: false,
      isBtnDisabled: false,
      posiStrInfoList: [],
      posiQuickStrInfoList: [],
      recentDvya: {},
    }
  },
  watch: {
    outerVisible (data) {
      if (data) {
        if (this.ppupType === 'pdDtl' || this.ppupType === 'mass') {
          this.list = []
        } else {
          this.selIdx = -1
        }
        this.selRecentDvya()
        this.dvyaList()
      }
    },
    purchaseValue (val) {
      if (val === '04') { // 배송 유형 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
  },
  async mounted () {
    if ((this.ppupType === 'pdDtl' || this.ppupType === 'mass') && this.isLogin) {
      await this.dvyaList()
    }
  },
  methods: {
    popupCloseCallback (form) {
      console.log('form ::: ', form)
      this.$emit('popupCloseCallback', form)
      this.$refs.mbc011502.outerVisible = false
    },
    moreView () {
      this.moreYn = this.moreYn === 'Y' ? 'N' : 'Y'
    },
    dvyaList (updForm) {
      this.isLoaded = false
      return this.$AxiosBuilder
        .data()
        .build()
        .post('/mb/mbc/selDvya')
        .then((res) => {
          this.list = Array.isArray(res.data.data) ? res.data.data : []
          if (this.isNotEmpty(res.data.data)) {
            if (this.ppupType === 'ora') {
              this.$emit('initData', this.list)
            } else if (this.ppupType !== 'pdDtl') {
              this.$emit('initData', this.list)
            }
            this.selIdx = 0
            if (this.list.length > 0) {
              const zipList = {
                zipList: this.list.map(row => row.addrZip)
              }
              this.selPosiStrInfoList(zipList) // 거점매장리스트 조회
              this.selPosiQuickStrInfoList(zipList) // 오늘배송매장리스트 조회
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    dvyaAdit () {
      if (this.list.length >= 20) {
        this.$alert(this.$t('SM.MAX_SAVE_DELIVERY'))
      } else {
        if (this.list.length === 0) {
          this.$refs.mbc011502.bassDvyaYnDisabled = true
        } else {
          // 2024.01.17. 기본배송지가 있는 상태에서 새 배송지 추가 시 기본배송지 여부 선택 가능하도록
          this.$refs.mbc011502.bassDvyaYnDisabled = false
        }
        Object.assign(this.$refs.mbc011502.form, this.$refs.mbc011502.$options.data().form)
        this.$refs.mbc011502.form.action = 'ins'
        this.$refs.mbc011502.outerVisible = true
      }
    },
    dvyaDel (item) {
      this.$confirm(this.$t('SM.DELETE_DELIVERY_CONFIRM'), '', {
        cancelButtonText: '아니오',
        confirmButtonText: '예',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        await this.$AxiosBuilder
          .data(item)
          .build()
          .post('/mb/mbc/upDvyaUseYn')
          .then((res) => {
            if (this.isNotEmpty(res.data.data)) {
              const data = res.data.data
              if (res.data.success) {
                if (item.bassDvyaYn === 'Y' && this.list.length > 1) {
                  this.bassDvyaUpdt(this.list[1])
                } else {
                  this.$emit('getData', '')
                }
                this.dvyaList()
              } else {
                this.$alert(data, '', {
                  confirmButtonText: '확인', /* 확인 */
                  dangerouslyUseHTMLString: true
                })
              }
            }
          })
          .catch((err) => {
            console.log('error')
            console.log(err)
          })
      }).catch(() => {
        // 취소버튼
      })
    },
    dvyaUpdt (idx) {
      this.assignNotNull(this.$refs.mbc011502.form, this.list[idx])
      this.$refs.mbc011502.bassDvyaYnDisabled = this.list[idx].bassDvyaYn === 'Y' // 2024.01.18. 기본배송지 체크 해제 불가능하도록
      this.$refs.mbc011502.form.action = 'upd'
      this.$refs.mbc011502.outerVisible = true
    },
    bassDvyaUpdt (item) {
      const data = item || this.list[this.selIdx]
      this.$AxiosBuilder
        .data(data)
        .build()
        .post('/mb/mbc/upBassDvya')
        .then((res) => {
          console.log(res)
          if (this.isNotEmpty(res.data.data)) {
            if (res.data.success) {
              this.dvyaList()

              this.$emit('getData', { ...data, bassDvyaYn: 'Y' })
            } else {
              this.$alert(data, '', {
                confirmButtonText: '확인', /* 확인 */
                dangerouslyUseHTMLString: true
              })
            }
            // Store 업데이트: 배송지가 변경되었음을 전역 상태에 알림
            if (res.data.success) {
              this.setCurrentDeliveryAddress({ ...data, bassDvyaYn: 'Y' })
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    cancleClick () {
      // 2023.11.29 배송지 없는 상태 > 배송지등록화면 표출 > 등록없이 닫기 > 장바구니 회귀
      if (this.list.length === 0) {
        this.outerVisible = false
      }
    },
    closeClick () {
      // 2023.12.06 닫기클릭 시 emit
      this.$emit('closeClick', '')
      this.outerVisible = false
    },
    selPosiStr () {
      const copyList = this.list
      copyList?.forEach((item, index) => {
        this.selPosiStrInfo(item?.addrZip).then((response) => {
          if (!response?.strLgctCntrCd) {
            item.ableDlv = true
            this.list.splice(index, 1, item)
          } else {
            item.ableDlv = false
            this.list.splice(index, 1, item)
          }
        })
      })
    },
    selPosiStrInfoList (zipList) { // 거점매장리스트 조회
      this.$AxiosBuilder
        .data(zipList)
        .build()
        .post('/dl/dla-api/selPosiStrInfoList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const resData = res.data.data
            this.posiStrInfoList = resData
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selPosiQuickStrInfoList (zipList) { // 오늘배송매장리스트 조회
      this.$AxiosBuilder
        .data(zipList)
        .build()
        .post('/dl/dla-api/selPosiQuickStrInfoList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const resData = res.data.data
            this.posiQuickStrInfoList = resData
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selRecentDvya () { // 최근배송지조회
      const param = {
        orNo: '',
        dlvFomCd: '',
        gfYn: '',
        status: '',
        currentPageCnt: 1,
        strtDt: dayjs().month(dayjs().month() - 12).format('YYYYMMDD'),
        endDt: dayjs().format('YYYYMMDD'),
        orStsCd: '',
        rowNumber: '',
        currentPage: 1, // 페이지 번호 현재 페이지 번호를 나타냄
        pageSize: 1, // 페이지 사이즈 기본 10
        orTyCd: 'rct' // 주문 유형 (rct - 매장픽업, 상품권 제외)
      }
      this.$AxiosBuilder
        .data(param)
        .build()
        .post('/or/orb/selOr')
        .then(async (res) => {
          const result = res.data
          if (result.success) {
            const recentDvya = await this.callApi('/or/orb/orDts/selOrDtl', { orNo: result.data[0].orNo })
            this.recentDvya = recentDvya
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    async callApi (url, params) {
      return await this.$AxiosBuilder
        .data(params)
        .build()
        .post(url)
        .then((res) => {
          return res.data.data
        })
    },
    async setDvya (item) {
      // 주문 배송지 변경 모드: 선택된 배송지를 기본배송지(bass_dvya_yn='Y')로 설정하고, 별도 callback으로 전달
      // (주문완료/주문목록/주문상세에서만 사용, 해당 페이지는 @getData 미바인딩이라 기존 로직 영향 없음)
      if (this.ppupType === 'orDvyaChg') {
        // 선택한 배송지가 도서산간 지역이면 배송지 변경 불가
        if (await this.chkIsmtDlvYn('01', '01', item.addrZip)) {
          this.$alert('도서산간 지역은 배송지 변경이 불가합니다.<br>변경을 원하시면 주문 취소 후<br>다시 주문해 주세요.', '', { dangerouslyUseHTMLString: true })
          return
        }
        this.$confirm('배송지를 변경하면 사전 안내된<br>배송예정일이 달라질 수 있습니다.<br>배송지를 변경하시겠습니까?', '', {
          cancelButtonText: '취소',
          confirmButtonText: '배송지 변경',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.bassDvyaUpdt(item) // 기본배송지 변경(bass_dvya_yn='Y')
          this.$emit('selDvyaForOrChg', item)
          this.outerVisible = false
        }).catch(() => {
          // 취소
        })
        return
      }
      this.bassDvyaUpdt(item)
      this.outerVisible = false
    },
    editData (data) {
      if (data.bassDvyaYn === 'Y') {
        this.$emit('getData', data)
        this.setCurrentDeliveryAddress(data)
      } else {
        this.$emit('getData')
      }
    },
    ...mapActions('delivery', ['setCurrentDeliveryAddress'])
  }
}
